import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    Form, Icon, Input, Button,
} from 'antd';
import { loginRequest } from '../redux/actions/account_actions/login.actions';
import { validation_rules } from '../../../shared/validation_rules';
import { WelcomeTitle } from './WelcomeTitle';

const FormItem = Form.Item;

class LogInForm extends Component {
    state = {
        login: '',
        password: '',
    };

    handleChange = (event) => this.setState({ [event.target.name]: event.target.value });

    handleSubmit = (event) => {
        event.preventDefault();
        const { login, password } = this.state;
        this.props.dispatch(loginRequest({ login, password }));
    };

    render() {
        const { login, password } = this.state;
        const { loading } = this.props;

        return (
            <div className="account">
                <div className="account__wrapper">
                    <div className="account__card">
                        <WelcomeTitle>
                            <h4 className="account__subhead subhead">Log into the SuperBike Factory platform</h4>
                        </WelcomeTitle>
                        <Form onSubmit={this.handleSubmit} className="login-form">
                            <FormItem label="Email Address">
                                <Input
                                    value={login}
                                    type="email"
                                    name="login"
                                    maxLength={50}
                                    prefix={<Icon type="mail" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                    placeholder="Email Address"
                                    onChange={this.handleChange}
                                />
                            </FormItem>
                            <span className="validationError">{login && validation_rules.email(login)}</span>
                            <FormItem label="Password">
                                <Input.Password
                                    value={password}
                                    maxLength={20}
                                    name="password"
                                    prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                    placeholder="Password"
                                    onChange={this.handleChange}
                                />
                            </FormItem>
                            <span className="validationError">{password && validation_rules.password(password)}</span>
                            <FormItem>
                                <Button
                                    type="primary"
                                    loading={loading}
                                    style={{ width: '100%' }}
                                    htmlType="submit"
                                >
                                    Sign In
                                </Button>
                            </FormItem>
                        </Form>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({ loading: state.App.Permissions.loading });

export default connect(mapStateToProps)(LogInForm);



// WEBPACK FOOTER //
// ./src/modules/App/components/LogInForm.js